import DateInput from './DataInput';

export default DateInput;
